export default __webpack_public_path__ + "../staticImages/trusted_shop.png";